// EditPasswordTemplate.js
import React from "react";
import EditPasswordForm from "../organisms/editPasswordForm";

export default function EditPasswordTemplate() {
  return <EditPasswordForm />;
}